import * as React from 'react'
import { styled, css } from 'next-yak'

import * as plume from '@ulule/owl-kit-components/next'

import { UluleLogo } from '../logos/UluleLogo'
import * as S from '../style'
import { t } from '@owl-nest/localize'

import { useURLContext } from '../../context/urls/urlContext'
import { getUrlWithUTMs } from '../../utils/urls'

type CenterProps = {
  siteIdentifier: string
}

export function Center({ siteIdentifier }: CenterProps): React.ReactElement<CenterProps> {
  const urlContext = useURLContext()

  const breakpointType = S.INTERMEDIATE_BREAKPOINT_TYPE

  return (
    <Wrapper $breakpoint={breakpointType}>
      <a href={getUrlWithUTMs(urlContext.home, siteIdentifier, 'ulule', 'logo')} aria-label={t('Ulule home')}>
        <UluleLogo />
      </a>
    </Wrapper>
  )
}

const Wrapper = styled.div<{ $breakpoint: S.BreakpointType }>`
  align-items: center;
  display: flex;
  height: 33px;
  justify-content: center;
  margin: 0;
  padding: 0;
  position: relative;
  width: 100%;

  svg {
    height: 100%;
  }

  a {
    color: ${plume.COLORS.TEXT_PRIMARY}; // Force color on logo for legacy pages
  }

  ${({ $breakpoint }) => {
    if ($breakpoint === 'custom') {
      return css`
        @media screen and ${S.CUSTOM_INTERMEDIATE_BREAKPOINT} {
          display: none;
        }
      `
    }
    if ($breakpoint === 'laptop') {
      return css`
        @media screen and ${plume.BREAKPOINTS.LAPTOP} {
          display: none;
        }
      `
    }
  }}
`
